// extracted by mini-css-extract-plugin
export default {"table":"table_table__5DTE2","selected":"table_selected__IlqWQ"};